import cartAddNewAddressHtml from './cartaddnewaddress.component.html';
import './cartaddnewaddress.component.scss';

class CartAddNewAddressController {
    constructor($scope, $http, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.SnackbarService = SnackbarService;
        
        this.countries = window.countries || ['Polska'];
        this.loading = false;
        this.showAllErrors = false;

        this.data = {
            addressName: '',
            firstName: '',
            lastName: '',
            companyName: '',
            taxNumber: '',
            street: '',
            houseNumber: '',
            flatNumber: '',
            city: '',
            zipCode: '',
            country: 'Polska'
        };

        this.dataValidations = {
            addressName: () => this.data.addressName != '',
            firstName: () => this.type == 0 || this.data.firstName != '',
            lastName: () => this.type == 0 || this.data.lastName != '',
            companyName: () => this.type == 1 || this.data.companyName != '',
            taxNumber: () => {
                if (this.type != 1 || this.data.taxNumber != '') {
                    const taxNumber = this.data.taxNumber;
                    if (this.data.country === 'Polska') {
                        const nip = taxNumber.replace(/[^0-9]/g, '');
                        if (nip.length === 10 && parseInt(nip, 10) > 0) {
                            const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                            let sum = 0;
                            for (let i = 0; i < 9; i++) {
                                sum += parseInt(nip[i], 10) * weights[i];
                            }

                            return (sum % 11) === Number(nip[9]);
                        }

                        return false;
                    } else {
                        return /^[A-Za-z0-9]{1,20}$/.test(taxNumber);
                    }
                }

                return this.type == 1 || this.data.taxNumber != '';
            },
            street: () => this.data.street != '',
            houseNumber: () => this.data.houseNumber != '',
            city: () => this.data.city != '',
            zipCode: () => this.data.zipCode != ''
        };
    }

    get isValid() {
        for (const validatorFnName in this.dataValidations) {
            if (!this.dataValidations[validatorFnName]()) return false;
        }
    
        return true;
    }

    $onInit() {
        this.data.type = parseInt(this.type);

        if (this.data.type == 1) {
            this.data.country = this.country;
        }
    }

    save() {
        this.showAllErrors = true;

        if (!this.isValid) return;

        this.loading = true;

        this.$http.post(
            '/ajax/checkout/add-new-address',
            this.data
        ).then(
            (response) => {
                this.loading = false;

                const id = response.data.data.addressId;

                this.$scope.$parent.$ctrl.close({id, data: this.data});
            },
            (error) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let cartAddNewAddressComponent = {
    bindings: {
        type: '<',
        country: '@'
    },
    template: cartAddNewAddressHtml,
    controller: CartAddNewAddressController
}

export default cartAddNewAddressComponent;